import { DetailView } from '@components/enitity'
import { LandlordsForm } from '@features/landlords/components/LandlordsForm'
import { useCreateClient } from '@services/users/mutations'
import { useTranslation } from 'react-i18next'

export function LandlordsCreate() {
  const { t } = useTranslation('users')
  const { mutate: createLandlord } = useCreateClient()

  return (
    <div>
      <DetailView.Breadcrumb
        parentLabel={t('landlords')}
        parentTo="/admin/landlords"
        current={t('form.buttons.create', { defaultValue: 'Nový' })}
      />

      <LandlordsForm submitForm={createLandlord} />
    </div>
  )
}
